import { gql } from '@/lib/graphql/gql'

export const CREATE_DATABASE_QUERY = gql`
  query CreateDatabaseInfo($idCompany: String!) {
    company(id: $idCompany) {
      id
      databases {
        id
        total
      }
      sevallaBilling {
        id
        creditUsage {
          id
          remainingCredits
        }
      }
      defaultPaymentMethod {
        id
        expYear
        expMonth
      }
      projects {
        id
        items {
          id
          displayName
        }
      }
    }
  }
`

export const CREATE_DATABASE_MUTATION = gql`
  mutation CreateDatabase(
    $idCompany: String!
    $idProject: String
    $data: DatabaseData!
    $displayName: String!
    $idCluster: String!
    $idResourceType: String!
    $type: DatabaseType!
    $version: String!
    $extensions: DatabaseExtensions
    $externalBackup: DatabaseExternalBackup
  ) {
    createDatabase(
      idCompany: $idCompany
      idProject: $idProject
      data: $data
      displayName: $displayName
      idCluster: $idCluster
      idResourceType: $idResourceType
      type: $type
      version: $version
      extensions: $extensions
      externalBackup: $externalBackup
    ) {
      id
      name
    }
  }
`
